import { Component, Input, OnInit } from '@angular/core';
import { CommonService } from 'src/app/services/common.service';

@Component({
  selector: 'calsoft-plan-compare-type13',
  templateUrl: './plan-compare-type13.component.html',
  styleUrls: ['./plan-compare-type13.component.scss']
})
export class PlanCompareType13Component implements OnInit{
  isChecked: boolean = false;
  pricedetail: any;
  
  @Input() item: any;
  @Input() data: any;
  
  constructor(private commonService: CommonService) {}
  
  ngOnInit() {
    this.pricedetail = JSON.parse(this.item.customField31);
  }
  
  setToggle(value: boolean) {
    if (this.isChecked !== value) {
      this.isChecked = value;
      this.toggleChanged();  // Keep your existing logic here
    }
  }
  
  toggleChanged() {
    console.log('Toggle changed. New value:', this.isChecked);
  }
  
  openInNewWindow(url: string) {
    if (url) {
      const fullURL = this.prependProtocol(url);
      this.commonService.goToLink(url);
    }
  }
  
  prependProtocol(url: string): string {
    if (!url.includes('http://') && !url.includes('https://')) {
      return 'https://' + url;
    }
    return url;
  }
  

  selectedPlan: string = 'monthly';

  selectPlan(plan: string) {
    this.selectedPlan = plan;
  }
  



}

